import { z } from "zod";

export const ModifyOrderBodySchema = z.object({
  takeProfit: z.number().nullable(),
  stopLoss: z.number().nullable(),
});

export type ModifyOrderBodyType = z.infer<typeof ModifyOrderBodySchema>;

export default ModifyOrderBodySchema;
